import { initializeApp } from 'firebase/app'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
	apiKey: 'AIzaSyASVuK6TC0wAsW7n4uOw_7IBM7byIPomvA',
	authDomain: 'creativepeoples-3fe7d.firebaseapp.com',
	projectId: 'creativepeoples-3fe7d',
	storageBucket: 'creativepeoples-3fe7d.appspot.com',
	messagingSenderId: '512609291775',
	appId: '1:512609291775:web:c4d002e0a708e6e1112bca',
}

initializeApp(firebaseConfig)

const storage = getStorage()

export { storage }
